var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "onboarding-choice" },
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.$t.__("pdp.mandate.OnboardingChoice.tooltip"),
            disabled: !_vm.disabled,
            arrow: false
          }
        },
        [
          _c(
            "button",
            {
              class: _vm.classes,
              attrs: { disabled: _vm.disabled },
              on: {
                click: function($event) {
                  return _vm.$emit("select", _vm.type)
                }
              }
            },
            [
              _c("img", {
                attrs: {
                  src:
                    "/ressources/logged/img/illustrations/pdp/" +
                    _vm.icon +
                    ".svg",
                  alt: _vm.label
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "onboarding-choice__button-label" }, [
                _vm._v(
                  "\n                " + _vm._s(_vm.label) + "\n            "
                )
              ]),
              _vm._v(" "),
              _vm.state === _vm.BUTTON_STATES.SELECTED
                ? _c("CompassIcon", { attrs: { icon: "success-circle-fill" } })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.showTags
        ? _c(
            "div",
            { staticClass: "onboarding-choice__tags" },
            [
              _c("CompassTag", { attrs: { color: "stroked", size: "small" } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t.__("pdp.mandate.OnboardingChoice.issue.tag")
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _vm.type === "receipt"
                ? _c(
                    "CompassTag",
                    { attrs: { color: "stroked", size: "small" } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t.__(
                              "pdp.mandate.OnboardingChoice.receipt.tag"
                            )
                          ) +
                          "\n        "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "onboarding-choice__checklist" },
        _vm._l(_vm.checklist, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass:
                "onboarding-choice__item typographies-paragraph-medium-regular"
            },
            [
              _c("CompassIcon", {
                attrs: { icon: "success-circle", size: "small" }
              }),
              _vm._v("\n            " + _vm._s(item) + "\n        ")
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }